import React, { useEffect, useState, useRef } from 'react';
import {
  useTable,
  useSortBy,
  useGlobalFilter,
  usePagination,
  TableInstance,
} from 'react-table';
import { Navigate, useNavigate } from 'react-router-dom';
import SelectField from 'components/fields/SelectField';

// Chakra imports
import {
  Flex,
  Text,
  Icon,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
  Box,
  Button,
  SimpleGrid,
  Tooltip,
  useToast,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import { getCompanyList, getSelectCreator } from 'utils/creator/creator';

import {
  getGameSpecific,
  // getLearnerFilter,
} from 'utils/activitycontrols/activities';
import { getGameList } from 'utils/game/gameService';
import { getcohortslist } from 'utils/cohorts/cohorts';
import { formToJSON } from 'axios';
import { SearchIcon,CheckIcon } from '@chakra-ui/icons';
import InputField from 'components/fields/InputField';
import { HashLoader } from 'react-spinners';
import {
  IconButton,
  InputGroup,
  InputLeftElement,
  useColorModeValue,
} from '@chakra-ui/react';
import { set } from 'lodash';

interface LearnerActivityData {
  sNo: number;
  originalScore: any;
  finalScore: any;
  Improvement: any;
  interaction: any;
  approaches: string;
  learners: number;
  game: string;
  content: string;
  relevance: string;
  behaviour: string;
  recommendation: string;
  gamification: string;
}
type RowObj = {
  sNo: number;
  originalScore: any; // Corresponds to 'Original Score' in Skills
  finalScore: any; // Corresponds to 'Final Score' in Skills
  Improvement: any; // Corresponds to 'Improvement' in Skills
  interaction: any; // Corresponds to 'Interaction' in Approaches
  approaches: string; // Corresponds to 'Approaches' in Approaches
  learners: number; // Corresponds to 'Learners %' in Approaches
  game: string; // Corresponds to 'Game' in Feedback
  content: string; // Corresponds to 'Content' in Feedback
  relevance: string; // Corresponds to 'Relevance' in Feedback
  behaviour: string; // Corresponds to 'Behaviour' in Feedback
  recommendation: string; // Corresponds to 'Recommendation' in Feedback
  gamification: string; // Corresponds to 'Gamification' in Feedback
};


interface ColumnObj {
  Header: number | string;
  accessor: any;
  columns?: any[];
}


type DataCol = TableInstance<RowObj>;

const Gamespecific = ({}) => {
  const [isHovering, setIsHovering] = useState(false);
  const tableRef = useRef<HTMLDivElement | null>(null);
  const [localPageIndex, setLocalPageIndex] = useState(0);
  const [localPageSize, setLocalPageSize] = useState(10);
  const [feedbackData, setFeedbackData] = useState([]);
  const [data, setData] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [gameNames, setGames] = useState([]);
  const [cohort, setcohort] = useState([]);
  const [companyNames, setCompany] = useState([]);
  const storage = JSON.parse(localStorage.getItem('user'));
  const toast = useToast();
  let storageCreatorId = '';
  const UserRole = storage.data.role;
  if (storage.data.role === 'Creator') {
    storageCreatorId = storage.data.id;
  }
  let storagelenNameId = '';
  const UserRolee = storage.data.role;
  if (storage.data.role === 'Creator') {
    storagelenNameId = storage.data.id;
  }
  const [lastPage, setLastPage] = useState<any>();
  const [AllLearners, setAllLearners] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);

  const [creatorOptions, setCreatorOptions] = useState([]);

  const [selected, setSelected] = useState({
    companyId: '',
    creatorId: '',
    lenUserName: '',
    galGameId: '',
    cohortId: '',
    date: '',
  });
  const [loadingdata, setLoadingdata] = useState(false);

  const [filteredCreators, setFilteredCreators] = useState([]);
  const [filteredGameOptions, setFilteredGameOptions] = useState([]);
  const [creators, setCreators] = useState([]);
  const [GameOptions, setGameOptions] = useState([]);
  const [cohortOption, setCohortOption] = useState([]);

  const navigate = useNavigate();
  const searchIconColor = useColorModeValue('gray.700', 'white');
  let menuBg = useColorModeValue('white', 'navy.800');
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)',
  );
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  interface OptionTypecon {
    value: string;
    label: string;
    CompanyId: string;
    lenUserName: string;
    galGameId: string;
    cohortId: string;
  }

  const galGameId = apiData.map((data: any) => data.galGameId);



  const [selectedButton, setSelectedButton] = useState(0);

  const [randomColumns, setColumns] = useState<ColumnObj[]>([]);




  useEffect(() => {
    toast({
      // title: `Please select Atleast one game to see specifics`,
      title: `Please select atleast one game to see specifics`,
      position: 'top',
      status: 'error',
      isClosable: true,
    });
  }, []);

  
//   const fetchGameSpecific = async (term: string, gameId?: any) => {
//   setLoadingdata(true); // start loader immediately

//   try {
//     const bind = {
//       gameId: gameId || '',
//       tab: term,
//       ...selected,
//       cohortId: selected.cohortId,
//       date: selected.date,
//     };

//     const molded = JSON.stringify(bind);
//     const result = await getGameSpecific(molded);

//     if (result?.status !== 'Success') return;
//       return; // loader will stop in finally
    

//     const rest = result?.data ?? [];
//     const trans = transformData(rest);
//     setData(trans);
//   } catch (error) {
//     console.error('Error fetching game-specific data:', error);
//   } finally {
//     setLoadingdata(false); // loader ALWAYS stops here
//   }
// };


const fetchGameSpecific = async (term: string, gameId?: any) => {
  setLoadingdata(true);
  try {
    const bind = {
      gameId: gameId || '',
      tab: term,
      ...selected,
      cohortId: selected.cohortId,
      date: selected.date,
    };
    const molded = JSON.stringify(bind);
    const result = await getGameSpecific(molded);

    if (result?.status !== 'Success') return;

    const rest = result?.data ?? [];
    const trans = transformData(rest);
    setData(trans);
  } catch (error) {
    console.error(error);
  } finally {
    setLoadingdata(false); // loader hides here only
  }
};

  const handleSelectClick = async (selectedOption: any) => {

    const gameId = selectedOption?.value;

    setSelected((prevSelected) => ({
      ...prevSelected,
      galGameId: selectedOption ? gameId : null,
    }));
   
  };
  const dropdown = async () => {
    switch (selectedButton) {
      case 0:
        await fetchGameSpecific('skills', selected?.galGameId);
        break;
      case 1:
        await fetchGameSpecific('approaches', selected?.galGameId);
        break;
      case 2:
        await fetchGameSpecific('feedback', selected?.galGameId);
        break;
      default:
        console.warn('Invalid button selected');
    }
  };

  useEffect(() => {
    dropdown();
  }, [selected]); // Add dependencies here if needed

  const handleCohortClick = async (selectedOption: any) => {
    const cohortId = selectedOption?.value;

    setSelected((prevSelected) => ({
      ...prevSelected,
      cohortId: selectedOption ? cohortId : null,
    }));
  };

  // Assuming you're using a React component
  const handleDateClick = async (
    event: React.ChangeEvent<HTMLInputElement>,
    value: any,
    selectedOption: any,
  ) => {
    const date = event.target.value;

    setSelected((prevSelected) => ({
      ...prevSelected,
      date: date,
    }));
  };
  useEffect(() => {
    const Skills: ColumnObj[] = [
      { Header: 'sNo', accessor: 'sNo' },
      { Header: 'Skill', accessor: 'Skill' },
        { Header: 'AssignDate', accessor: 'AssignDate' },
      { Header: 'CohortName', accessor: 'CohortName' },
      { Header: 'OriginalScore', accessor: 'OriginalScore' },
      { Header: 'FinalScore', accessor: 'FinalScore' },
      { Header: 'Improvement', accessor: 'Improvement' },
    
    ];

    const Approaches: ColumnObj[] = [
      { Header: 'sNo', accessor: 'sNo' },
      { Header: 'Interaction', accessor: 'interaction' },
        { Header: 'AssignDate', accessor: 'AssignDate' },
      { Header: 'CohortName', accessor: 'CohortName' },
      { Header: 'Approaches', accessor: 'approaches' },
      { Header: 'Learners %', accessor: 'learners' },
    ];
    const Feedback: ColumnObj[] = [
      { Header: 'sNo', accessor: 'sNo' },
      { Header: 'Game', accessor: 'game' },
        { Header: 'AssignDate', accessor: 'AssignDate' },
      { Header: 'CohortName', accessor: 'CohortName' },
      { Header: 'Content', accessor: 'content' },
      { Header: 'Relevance', accessor: 'relevance' },
      { Header: 'Behaviour', accessor: 'behaviour' },
      { Header: 'Recommendation', accessor: 'recommendation' },
      { Header: 'Gamification', accessor: 'gamification' },
    ];

    if (selectedButton === 0) {
      setColumns(Skills);
      fetchGameSpecific('skills', selected?.galGameId);
    }

    if (selectedButton === 1) {
      fetchGameSpecific('approaches', selected?.galGameId);
      setColumns(Approaches);
    }

    if (selectedButton === 2) {
      fetchGameSpecific('feedback', selected?.galGameId);
      setColumns(Feedback);
    }
  }, [UserRole, selectedButton]);

  const columns = React.useMemo(() => {
    return [...randomColumns];
  }, [randomColumns]);

  const handleButtonClick = (index: any) => {
    setSelectedButton(index);
  };



  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    state: { pageIndex, pageSize, globalFilter },
    setGlobalFilter,
    gotoPage,
    setPageSize,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
  }: DataCol = useTable<RowObj>(
    {
      columns,

      data: data,
      initialState: { pageIndex: localPageIndex, pageSize: localPageSize },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  useEffect(() => {
    const lastPage = Math.floor(data.length / pageSize);
    setLastPage(Math.floor(data.length / pageSize));
  }, []);

  const totalPages = Math.ceil(data.length / pageSize);

  const handleGoPage = (pageNumber: number) => {
    if (pageNumber >= 0 && pageNumber < totalPages) {
      setLocalPageIndex(pageNumber);
      gotoPage(pageNumber);
    }
  };

  const getPageNumbers = () => {
    const pageCount = 3;
    const currentPage = pageIndex + 1;
    const pages = [];

    if (totalPages <= pageCount) {
      for (let i = 0; i < totalPages; i++) {
        pages.push(i + 1);
      }
    } else {
      const start = Math.max(1, currentPage - Math.floor(pageCount / 2));
      const end = Math.min(totalPages, start + pageCount - 1);

      if (start > 1) {
        pages.push(1, '...');
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (end < totalPages) {
        pages.push('...', totalPages);
      }
    }

    return pages;
  };

  useEffect(() => {
    const handleWheel = (e: WheelEvent) => {
      if (isHovering && tableRef.current) {
        // Prevent vertical scroll on body
        if (e.deltaY !== 0) {
          e.preventDefault();
          // Scroll horizontally based on vertical scroll movement
          tableRef.current.scrollLeft += e.deltaY;
        }
      }
    };

    // Add event listener for scroll on window
    if (isHovering) {
      window.addEventListener('wheel', handleWheel, { passive: false });
    } else {
      window.removeEventListener('wheel', handleWheel);
    }

    return () => {
      // Cleanup the event listener
      window.removeEventListener('wheel', handleWheel);
    };
  }, [isHovering]);

  useEffect(() => {
    const fetchData = async () => {
    
      try {
        // const AllLearner = await getLearnerFilter();
        // setAllLearners(AllLearner.data);
        // if (AllLearner?.status !== 'Success')
        //   return console.log('AllLearner Error:', AllLearner?.message);

        // if (UserRole === 'AllLearner') {
        //   const selectAllLearnerData: OptionTypecon[] = AllLearner?.data || [];
        //   const foundItem = selectAllLearnerData.find(
        //     (item) => item.value === storagelenNameId,
        //   );
        //   setSelected({ ...selected, lenUserName: foundItem?.lenUserName });
        // }

        const company = await getCompanyList();
        setCompanyOptions(company?.data);
        setCompany(company?.data);
        if (company?.status !== 'Success')
          return console.log('getCountries Error:', company?.message);

        const game = await getGameList();

        if (game?.status !== 'Success')
          return console.log('getCountries Error :', game?.message);

        setGameOptions(game?.data);
        setGames(game?.data);

        try {
          const cohort = await getcohortslist();

          if (cohort?.status == 'Success') {
            setCohortOption(cohort?.data);
            setcohort(cohort?.data);
          } else {
            console.log('getCohortsList Error:', cohort?.message);
          }
        } catch (error) {
          console.log('Error fetching Cohorts:', error);
        }

        const creator = await getSelectCreator();

        if (creator?.status !== 'Success')
          return console.log('getPlanNames Error:', creator?.message);
        setCreatorOptions(creator.data);
        setCreators(creator.data);

        if (UserRole === 'Creator') {
          const selectCreatorData: OptionTypecon[] = creator?.data || [];
          const foundCompany = selectCreatorData.find(
            (item) => item.value === storageCreatorId,
          );

          if (foundCompany) {
            setSelected({
              ...selected,
              companyId: foundCompany.CompanyId,
              creatorId: foundCompany.value,
            });
          }
        }
      } catch (error) {
        console.error('An error occurred while fetching data:', error);
      } 
    };

    fetchData();
  }, []);

  const fixedColumnsCount = UserRole === 'Admin' ? 7 : 7;

  useEffect(() => {
    // Fetch data as before...

    if (UserRole === 'Admin' || UserRole === 'Creator') {
      const initialFiltered = UserRole === 'Creator' ? creators : [];
      setFilteredCreators(initialFiltered);
    }
  }, [UserRole, creators]);

  const transformData = (data: any[]) => {
    console.log(data,'dataingamespecific')
    let skillCounter = 1;
    let titleCount = 1;

    // Ensure data is an array
    if (!Array.isArray(data)) {
      console.error('Input data is not an array:', data);
      return [];
    }

    // Flatten and process the data
    return data.reduce((acc: any[], subArray: any[]) => {
      // Validate each sub-array
      if (!Array.isArray(subArray) || subArray.length === 0) return acc;

      // Process each item in the sub-array
      const processedItems = subArray.map((item: any, index: number) => {
        const skillName = item?.skillName || `Skill - ${skillCounter++}`;
        const interaction = item?.title || `Interaction - ${titleCount++}`;
  const AssignDate=item.createdDate;
     const CohortName=item.cohortName;
        // Handle scores with proper default values
        const originalScore =
          item?.averageScore != null ? `${item.averageScore}%` : 'N/A';
        const finalScore =
          item?.finalScore != null ? `${item.finalScore}%` : 'N/A';
        const improvement =
          item?.improvement != null ? `${item.improvement}%` : 'N/A';

        return {
          sNo: index + 1, // Serial number
          Skill: skillName,
          OriginalScore: originalScore,
          FinalScore: finalScore,
          Improvement: improvement,
          interaction: interaction,
          AssignDate:AssignDate,
          CohortName:CohortName,
          approaches: item?.options || [],
          learners: item?.options || [],
          game: item?.gameName || '',
          content: item?.count_feedContent || '',
          relevance: item?.count_feedRelevance || '',
          behaviour: item?.count_feedBehaviour || '',
          recommendation: item?.count_feedRecommendation || '',
          gamification: item?.count_feedGamification || '',
        };
      });

      return acc.concat(processedItems);
    }, []);
  };

  useEffect(() => {
    if (!GameOptions || GameOptions.length === 0) {
      return;
    }

    if (selected.creatorId) {
      const filteredGames = GameOptions.filter(
        (game) => game.creatorId === selected.creatorId,
      );
      setFilteredGameOptions(filteredGames);
    } else {
      setFilteredGameOptions(GameOptions);
    }
  }, [selected.creatorId, GameOptions]);

  const handleCompanyChange = (selectedOption: OptionTypecon | null) => {
    if (selectedOption) {
      setSelected({
        ...selected,
        companyId: selectedOption.value,
        creatorId: '',
        galGameId: '',
        cohortId: '',
      });
    } else {
      setSelected({
        ...selected,
        companyId: '',
        galGameId: '',

        // Reset gameId when no creator is selected
      });
    }
  };
  const handleCreatorIdChange = (selectedOption: OptionTypecon | null) => {
    if (selectedOption) {
      setSelected({
        ...selected,
        creatorId: selectedOption.value,
        companyId: selectedOption.CompanyId,
        galGameId: '', // Reset gameId when a new creator is selected
      });
    } else {
      setSelected({
        ...selected,
        creatorId: '',
        galGameId: '', // Reset gameId when no creator is selected
      });
    }
  };

  const handleClick = async () => {


    let data = JSON.stringify({
      ...selected,
      galGameId: selected.galGameId,
      cohortId: selected.cohortId,
      date: selected.date,
    });

  };

  useEffect(() => {
    handleClick();
  }, [
    selected.companyId,
    selected.creatorId,
    selected.lenUserName,
    selected.galGameId,
    selected.cohortId,
    selected.date,
  ]);
  useEffect(() => {
    if (selected.companyId) {
      const filteredCreators = creatorOptions.filter(
        (option: any) => option.CompanyId === selected.companyId,
      );

      const filteredGames = filteredGameOptions.filter((game) =>
        filteredCreators.some((creator) => creator.value === game.key),
      );
      setFilteredGameOptions(filteredGames);
    }
  }, [selected.companyId]);

  useEffect(() => {
    if (selected.creatorId) {
      const filteredCreators = creatorOptions.find(
        (option) => option.value === selected.creatorId,
      );

      const filteredGames = filteredGameOptions.filter(
        (option: any) => option.key === selected.creatorId,
      );
      setFilteredGameOptions(filteredGames);
    }
  }, [selected.creatorId]);
  return (
    <>
      {loadingdata && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(10px)',
          }}
        >
          <HashLoader color="#3b38e0" />
        </div>
      )}
      <h1
        style={{
          color: '#1b254b',
          fontSize: '34px',
          fontWeight: '500',
          margin: '20px',
        }}
      >
        Game Specifics
      </h1>

      <Card mt={'20px'} width={'100%'}>
        <SimpleGrid
          columns={{ base: 1, md: 3, lg: 3 }}
          // ml="30px"
          spacing={6}
        >
          {UserRole === 'Admin' || UserRole === 'Creator' ? (
            <>
              <SelectField
                mb="0px"
                id="ctCompanyId"
                name="companyId"
                label="Company Name"
                options={companyOptions}
                onChange={handleCompanyChange}
                value={
                  companyOptions.find(
                    (option) => option.value === selected.companyId,
                  ) || null
                }
                isDisabled={storage.data.role === 'Creator'}
                isClearable={true}
              />
              <SelectField
                mb="0px"
                id="ctCompanyId"
                name="planId"
                label="Creator Name"
                // options={creatorOptions}
                options={
                  selected.companyId
                    ? creatorOptions.filter(
                        (option: any) =>
                          option.CompanyId === selected.companyId,
                      )
                    : creatorOptions
                }
                onChange={handleCreatorIdChange}
                value={
                  creatorOptions.find(
                    (option) => option.value === selected.creatorId,
                  ) || null
                }
                isClearable={true}
              />
              <div>
                <SelectField
                  mb="0px"
                  id="gameId"
                  name="gameID"
                  label="Game Name"
                  options={filteredGameOptions}
                  onChange={handleSelectClick}
                  value={
                    filteredGameOptions.find(
                      (option) => option.value === selected.galGameId,
                    ) || null
                  }
                  isClearable={true}
                />
                {!selected.galGameId && (
                  <p style={{ color: 'grey', fontSize: '.75rem' }}>
                    Note* Please select any of game you want
                  </p>
                )}
              </div>
              <InputField
                mb="0px"
                name="Date"
                label="Assigned Date"
                type="date"
                onChange={handleDateClick}
              />

              <SelectField
                mb="0px"
                id="ctCompanyId"
                name="planId"
                label="Cohorts"
                // options={cohorts}
                options={
                  selected.companyId
                    ? cohortOption.filter(
                        (option: any) =>
                          option.companyId === selected.companyId,
                      )
                    : cohortOption
                }
                onChange={handleCohortClick}
                value={
                  cohortOption.find(
                    (option) => option.value === selected.cohortId,
                  ) || null
                }
                isClearable={true}
              />
            </>
          ) : null}
        </SimpleGrid>
      </Card>

      <Flex
        justifyContent="space-between"
        alignItems="center"
        align="center"
        mb="10px"
        p="20px 0"
        bg={menuBg} // Set background color here to match the box shadow
        boxShadow={shadow} // Apply box shadow to the container
        borderRadius="20px" // Optional: add border radius if needed
        width="100%" // Ensure full width
      >
        <Flex
          alignItems="center"
          flexDirection="row" // Ensure buttons are in a row
          flexWrap={{ base: 'wrap', md: 'nowrap' }}
          p="10px"
        >
          <Flex
            ml={4}
            mt={2}
            position="relative"
            color={textColor}
            fontSize={{ base: '14px', sm: '14px', md: '18px' }}
            fontWeight="500"
            me={{ base: '7px', sm: '7px', md: '12px' }}
            gap="10px"
          >
            <Box position="relative" mx={2}>
              <div
                style={{
                  cursor: 'pointer',
                  transition: '0.5s',
                  color: 'gray.500',
                }}
                onClick={() => handleButtonClick(0)} // Handle button click for Skills
              >
                Skills
              </div>
              {selectedButton === 0 && (
                <Box
                  position="absolute"
                  bottom="-10px"
                  left="50%"
                  transform="translateX(-50%)"
                  width="100%"
                  height="5px"
                  borderRadius="50px"
                  bg="#3311db"
                  transition="width 0.3s ease, opacity 0.3s ease"
                  opacity={selectedButton === 0 ? 1 : 0}
                />
              )}
            </Box>

            <Box position="relative" mx={2}>
              <div
                style={{
                  cursor: 'pointer',
                  transition: '0.5s',
                  color: 'gray.500',
                }}
                onClick={() => handleButtonClick(1)} // Handle button click for Approaches
              >
                Approaches
              </div>
              {selectedButton === 1 && (
                <Box
                  position="absolute"
                  bottom="-10px"
                  left="50%"
                  transform="translateX(-50%)"
                  width="100%"
                  height="5px"
                  borderRadius="50px"
                  bg="#3311db"
                  transition="width 0.3s ease, opacity 0.3s ease"
                  opacity={selectedButton === 1 ? 1 : 0}
                />
              )}
            </Box>

            <Box position="relative" mx={2}>
              <div
                style={{
                  cursor: 'pointer',
                  transition: '0.5s',
                  color: 'gray.500',
                }}
                onClick={() => handleButtonClick(2)} // Handle button click for Feedback
              >
                Feedback
              </div>
              {selectedButton === 2 && (
                <Box
                  position="absolute"
                  bottom="-10px"
                  left="50%"
                  transform="translateX(-50%)"
                  width="100%"
                  height="5px"
                  borderRadius="50px"
                  bg="#3311db"
                  transition="width 0.3s ease, opacity 0.3s ease"
                  opacity={selectedButton === 2 ? 1 : 0}
                />
              )}
            </Box>
          </Flex>
        </Flex>

        <InputGroup w={{ base: '100%', sm: '100%', md: '200px' }}>
          <InputLeftElement
            children={
              <IconButton
                aria-label="search"
                bg="inherit"
                borderRadius="inherit"
                _active={{
                  bg: 'inherit',
                  transform: 'none',
                  borderColor: 'transparent',
                }}
                _hover={{
                  background: 'none',
                }}
                _focus={{
                  background: 'none',
                  boxShadow: 'none',
                }}
                icon={
                  <SearchIcon
                    color={searchIconColor}
                    w="15px"
                    h="15px"
                    marginTop="20px"
                  />
                }
              />
            }
          />

          <Input
            type="text"
            placeholder="Search..."
            value={globalFilter || ''}
            onChange={(e) => setGlobalFilter(e.target.value)}
            bg="#f9f9f9"
            borderRadius="14px"
            w={{ base: '100%', sm: '100%', xl: '300px' }}
            marginRight="20px"
            marginTop="10px"
          />
        </InputGroup>
      </Flex>

      <Box
        overflowX={{ sm: 'scroll', xl: 'scroll' }}
        // overflowY={isHovering ? 'hidden' : 'scroll'} // Disable vertical scroll when inside table
        padding="2px"
        borderRadius={'13px 13px 20px 20px'}
        style={{ marginTop: '-10px' }}
      >
        <Table
          {...getTableProps()}
          variant={'simple'}
          style={{
            border: '2px solid #f7f7f7',
            width: '100%',
          }}
        >
          <Thead className="thead" bg={'#f9f9f9'}>
            {headerGroups.map((headerGroup) => (
              <Tr
                {...headerGroup.getHeaderGroupProps()}
                borderBottom={'2px solid #f7f7f7'}
              >
                {headerGroup.headers.map((column, index) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    color={'#191919'}
                    textAlign={'start'}
                    p={'10px 10px'}
                    style={{ whiteSpace: 'pre' }}
                  >
                    {column.render('Header')}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? ' 🔽'
                          : ' 🔼'
                        : ''}
                    </span>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>

          <Tbody {...getTableBodyProps()} fontSize={'17px'}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <Tr {...row.getRowProps()} borderBottom={'2px solid #f7f7f7'}>
                  {row.cells.map((cell, index) => {
                    const { column, value } = cell;
                    // if (column.id === 'approaches') {
                    //   return (
                    //     <Td
                    //       {...cell.getCellProps()}
                    //       background={'#f7f7f7'}
                    //       style={{ backgroundColor: 'white' }}
                    //     >
                    //       {value && value.length > 0
                    //         ? value.map((opt: any, index: any) => (
                              
                    //             <div
                    //               key={index}
                    //               style={{
                    //                 paddingTop: '5px',
                    //                 paddingBottom: '5px',
                    //               }}
                    //             >
                    //               {`${opt?.title}`}
                    //             </div>
                    //           ))
                    //         : 'No Options'}
                    //     </Td>
                    //   );
                    // }
                    if (column.id === 'approaches') {
  return (
    <Td
      {...cell.getCellProps()}
      background={'#f7f7f7'}
      style={{ backgroundColor: 'white' }}
    >
      {value && value.length > 0 ? (
        value.map((opt: any, index: any) => {
          const isCorrect = opt.correctAnswer === 'true';
          return (
            <div
              key={index}
              style={{
                paddingTop: '5px',
                paddingBottom: '5px',
               
              }}
            >
              {isCorrect && (
                <CheckIcon
                marginLeft= '-14px'
                 color="green" w="15px" h="15px" marginTop="2px" />
              )}
              <span>{opt?.title}</span>
            </div>
          );
        })
      ) : (
        'No Options'
      )}
    </Td>
  );
}

                    if (column.id === 'learners') {
                      return (
                        <Td
                          {...cell.getCellProps()}
                          background={'#f7f7f7'}
                          style={{ backgroundColor: 'white' }}
                        >
                          {value && value.length > 0
                            ? value.map((opt: any, index: any) => (
                                <div
                                  key={index}
                                  style={{
                                    paddingTop: '5px',
                                    paddingBottom: '5px',
                                  }}
                                >
                                  {`${opt?.percentage}`}
                                </div>
                              ))
                            : 'No Options'}
                        </Td>
                      );
                    }
                    return (
                      <Td
                        {...cell.getCellProps()}
                        className="learnerForAction"
                        p={'12px'}
                        textAlign={'start'}
                        style={{ backgroundColor: 'white' }}
                      >
                        {cell.render('Cell')}
                      </Td>
                    );
                  })}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </Box>

      <Box
        p={'20px 5px'}
        display={{ base: 'block', xl: 'flex' }}
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <Box mb={5}>
          <Box mr={'10px'} color={'#000'}>
            <span style={{ color: '#20212396' }}>
              Page{' '}
              <span>
                {pageIndex + 1} of {Math.ceil(data.length / pageSize)}
              </span>{' '}
            </span>
          </Box>
        </Box>
        <Box display={{ base: 'flex', xl: 'flex' }}>
          <Box mr={'10px'} display={'flex'} alignItems={'center'}>
            <Button
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
              bg={'#f3f0f0'}
              mr={'5px'}
              h={'40px'}
              w={'40px'}
              borderRadius="50%"
              lineHeight="1em"
              flexShrink={0}
              fontWeight={800}
            >
              {'<'}
            </Button>{' '}
            {getPageNumbers().map((page, index) => (
              <Button
                key={index}
                mr={'5px'}
                h={'40px'}
                w={'40px'}
                borderRadius="100px"
                lineHeight="1em"
                flexShrink={0}
                fontWeight={800}
                background={pageIndex + 1 === page ? '#3311db' : 'unset'}
                color={pageIndex + 1 === page ? '#fff' : 'unset'}
                onClick={() =>
                  typeof page === 'number' ? handleGoPage(page - 1) : null
                }
              >
                {page}
              </Button>
            ))}
            <Button
              onClick={() => nextPage()}
              disabled={!canNextPage}
              bg={'#f3f0f0'}
              h={'40px'}
              w={'40px'}
              borderRadius="100px"
              lineHeight="1em"
              flexShrink={0}
              fontWeight={800}
            >
              {'>'}
            </Button>{' '}
          </Box>
          <Box></Box>
        </Box>
      </Box>
    </>
  );
};

export default Gamespecific;
